module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_chapel-fff9dc18a97e7e0bf24e97d7e86dc8fd.jpg";